import { getAccountManagers } from '../../util/api';
import { storableError } from '../../util/errors';

// The account managers shown on the Team page.
//
// They used to be a static import — a list of names, addresses, numbers and
// photo files held in the client bundle. They now come from the database, so
// the page has to fetch them.
//
// The fetch runs in loadData, which means it also runs while the page is
// rendered on the server, so the managers are in the HTML that search engines
// read. See getUniversal in src/util/api.js for how that one call is made to
// work in Node as well as in the browser.

// ================ Action types ================ //

export const FETCH_MANAGERS_REQUEST = 'app/TeamAmPage/FETCH_MANAGERS_REQUEST';
export const FETCH_MANAGERS_SUCCESS = 'app/TeamAmPage/FETCH_MANAGERS_SUCCESS';
export const FETCH_MANAGERS_ERROR = 'app/TeamAmPage/FETCH_MANAGERS_ERROR';

// ================ Reducer ================ //

const initialState = {
  managers: [],
  fetchManagersInProgress: false,
  fetchManagersError: null,
};

export default function teamAmPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_MANAGERS_REQUEST:
      return { ...state, fetchManagersInProgress: true, fetchManagersError: null };
    case FETCH_MANAGERS_SUCCESS:
      return { ...state, managers: payload, fetchManagersInProgress: false };
    case FETCH_MANAGERS_ERROR:
      // The list is left as it was. On a first load that is empty and the page
      // shows its empty state; on a repeat visit the managers already there
      // are better than blanking the page.
      return { ...state, fetchManagersError: payload, fetchManagersInProgress: false };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchManagersRequest = () => ({ type: FETCH_MANAGERS_REQUEST });

export const fetchManagersSuccess = managers => ({
  type: FETCH_MANAGERS_SUCCESS,
  payload: managers,
});

export const fetchManagersError = e => ({
  type: FETCH_MANAGERS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchManagers = () => dispatch => {
  dispatch(fetchManagersRequest());

  return getAccountManagers()
    .then(response => {
      dispatch(fetchManagersSuccess(response.managers || []));
      return response.managers;
    })
    .catch(e => {
      dispatch(fetchManagersError(storableError(e)));
    });
};

export const loadData = () => dispatch => {
  return dispatch(fetchManagers());
};
